export function extractApiList(response) {
  const payload = response?.data?.data;
  if (Array.isArray(payload)) {
    return payload;
  }
  if (Array.isArray(payload?.results)) {
    return payload.results;
  }
  return [];
}

export function extractApiItem(response) {
  return response?.data?.data ?? null;
}

export function extractMeUser(meQueryData) {
  if (!meQueryData) {
    return null;
  }
  // DashboardLayout select: response.data → { status, code, data: user }
  // Nav historically reads data?.data?.data
  return meQueryData?.data?.data || meQueryData?.data || meQueryData;
}

export function resolveCompanyFromUser(user) {
  if (!user) {
    return null;
  }

  if (user.company && typeof user.company === 'object') {
    return {
      id: user.company.id,
      name: user.company.name,
      is_active: user.company.is_active,
      tariff_name: user.company.tariff_name
    };
  }

  const companyId = user.company_id || user.company || null;
  if (!companyId) {
    return null;
  }

  return { id: companyId, name: user.company_name || '' };
}

export function resolveBranchIdFromUser(user) {
  if (!user) {
    return null;
  }
  if (user.branch && typeof user.branch === 'object') {
    return user.branch.id ?? null;
  }
  return user.branch_id || user.branch || null;
}
